import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  id: "kt_aside_menu_wrapper",
  ref: "scrollElRef",
  class: "hover-scroll-overlay-y mb-5 mb-lg-5",
  "data-kt-scroll": "true",
  "data-kt-scroll-activate": "{default: false, lg: true}",
  "data-kt-scroll-dependencies": "#kt_aside_logo, #kt_aside_footer",
  "data-kt-scroll-height": "auto",
  "data-kt-scroll-offset": "0",
  "data-kt-scroll-wrappers": "#kt_aside_menu"
}
const _hoisted_2 = {
  id: "#kt_header_menu",
  class: " menu menu-column menu-title-gray-800 menu-state-title-primary menu-state-icon-primary menu-state-bullet-primary menu-arrow-gray-500 ",
  "data-kt-menu": "true"
}
const _hoisted_3 = {
  key: 0,
  class: "menu-item"
}
const _hoisted_4 = {
  key: 0,
  class: "menu-item"
}
const _hoisted_5 = { class: "menu-content pt-8 pb-2" }
const _hoisted_6 = { class: " menu-section text-muted text-uppercase fs-8 ls-1 " }
const _hoisted_7 = ["onClick"]
const _hoisted_8 = ["href", "onClick"]
const _hoisted_9 = {
  key: 0,
  class: "menu-icon"
}
const _hoisted_10 = {
  key: 1,
  class: "svg-icon svg-icon-2"
}
const _hoisted_11 = { class: "menu-title" }
const _hoisted_12 = ["href"]
const _hoisted_13 = {
  key: 0,
  class: "menu-icon"
}
const _hoisted_14 = {
  key: 1,
  class: "svg-icon svg-icon-2"
}
const _hoisted_15 = { class: "menu-title" }
const _hoisted_16 = { class: "menu-link" }
const _hoisted_17 = {
  key: 0,
  class: "menu-icon"
}
const _hoisted_18 = {
  key: 1,
  class: "svg-icon svg-icon-2"
}
const _hoisted_19 = { class: "menu-title" }
const _hoisted_20 = /*#__PURE__*/_createElementVNode("span", { class: "menu-arrow" }, null, -1)
const _hoisted_21 = {
  key: 0,
  class: "menu-item"
}
const _hoisted_22 = ["href", "onClick"]
const _hoisted_23 = /*#__PURE__*/_createElementVNode("span", { class: "menu-bullet" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "bullet bullet-dot" })
], -1)
const _hoisted_24 = { class: "menu-title" }
const _hoisted_25 = ["href"]
const _hoisted_26 = /*#__PURE__*/_createElementVNode("span", { class: "menu-bullet" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "bullet bullet-dot" })
], -1)
const _hoisted_27 = { class: "menu-title" }
const _hoisted_28 = { class: "menu-link" }
const _hoisted_29 = /*#__PURE__*/_createElementVNode("span", { class: "menu-bullet" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "bullet bullet-dot" })
], -1)
const _hoisted_30 = { class: "menu-title" }
const _hoisted_31 = /*#__PURE__*/_createElementVNode("span", { class: "menu-arrow" }, null, -1)
const _hoisted_32 = {
  key: 0,
  class: "menu-item"
}
const _hoisted_33 = ["href", "onClick"]
const _hoisted_34 = /*#__PURE__*/_createElementVNode("span", { class: "menu-bullet" }, [
  /*#__PURE__*/_createElementVNode("span", { class: " bullet bullet-dot " })
], -1)
const _hoisted_35 = { class: "menu-title" }
const _hoisted_36 = ["href"]
const _hoisted_37 = /*#__PURE__*/_createElementVNode("span", { class: "menu-bullet" }, [
  /*#__PURE__*/_createElementVNode("span", { class: " bullet bullet-dot " })
], -1)
const _hoisted_38 = { class: "menu-title" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_MOSearchContainer = _resolveComponent("MOSearchContainer")!
  const _component_inline_svg = _resolveComponent("inline-svg")!
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      (_ctx.isSearchEnabled())
        ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
            _createVNode(_component_MOSearchContainer, { class: "pt-4 pb-0" })
          ]))
        : _createCommentVNode("", true),
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.MainMenuConfig, (item, i) => {
        return (_openBlock(), _createElementBlock(_Fragment, { key: i }, [
          (item.heading && _ctx.isUserInheritRoles(item.roles) && _ctx.isAnyPageEnabled(item))
            ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                _createElementVNode("div", _hoisted_5, [
                  _createElementVNode("span", _hoisted_6, _toDisplayString(_ctx.translate(item.heading)), 1)
                ])
              ]))
            : _createCommentVNode("", true),
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.pages, (menuItem, j) => {
            return (_openBlock(), _createElementBlock(_Fragment, { key: j }, [
              (menuItem.heading && _ctx.isFeatureEnabled(menuItem.feature) && _ctx.isSiteEnabled(menuItem.siteIds) && !menuItem['isHidden'])
                ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                    (_ctx.isUserInheritRoles(menuItem.roles))
                      ? (_openBlock(), _createElementBlock("div", {
                          key: 0,
                          onClick: ($event: any) => (_ctx.handleOnboardingClick(menuItem.heading)),
                          class: "menu-item"
                        }, [
                          (menuItem.route)
                            ? (_openBlock(), _createBlock(_component_router_link, {
                                key: 0,
                                to: menuItem.route
                              }, {
                                default: _withCtx(({ href, navigate }) => [
                                  _createElementVNode("a", {
                                    class: _normalizeClass([[_ctx.isActivePath(menuItem.subsections) && 'active'], "menu-link"]),
                                    href: href,
                                    onClick: navigate
                                  }, [
                                    (menuItem.svgIcon || menuItem.fontIcon)
                                      ? (_openBlock(), _createElementBlock("span", _hoisted_9, [
                                          (_ctx.asideMenuIcons === 'font')
                                            ? (_openBlock(), _createElementBlock("i", {
                                                key: 0,
                                                class: _normalizeClass([menuItem.fontIcon, "bi fs-3"])
                                              }, null, 2))
                                            : (_ctx.asideMenuIcons === 'svg')
                                              ? (_openBlock(), _createElementBlock("span", _hoisted_10, [
                                                  _createVNode(_component_inline_svg, {
                                                    src: _ctx.originUrl + menuItem.svgIcon
                                                  }, null, 8, ["src"])
                                                ]))
                                              : _createCommentVNode("", true)
                                        ]))
                                      : _createCommentVNode("", true),
                                    _createElementVNode("span", _hoisted_11, _toDisplayString(_ctx.translate(menuItem.heading)), 1)
                                  ], 10, _hoisted_8)
                                ]),
                                _: 2
                              }, 1032, ["to"]))
                            : _createCommentVNode("", true),
                          (menuItem.url && _ctx.isFeatureEnabled(menuItem.feature) && _ctx.isSiteEnabled(menuItem.siteIds) && !menuItem['isHidden'])
                            ? (_openBlock(), _createElementBlock("a", {
                                key: 1,
                                href: _ctx.externalMenuUrl(menuItem.url),
                                class: "menu-link"
                              }, [
                                (menuItem.svgIcon || menuItem.fontIcon)
                                  ? (_openBlock(), _createElementBlock("span", _hoisted_13, [
                                      (_ctx.asideMenuIcons === 'font')
                                        ? (_openBlock(), _createElementBlock("i", {
                                            key: 0,
                                            class: _normalizeClass([menuItem.fontIcon, "bi fs-3"])
                                          }, null, 2))
                                        : (_ctx.asideMenuIcons === 'svg')
                                          ? (_openBlock(), _createElementBlock("span", _hoisted_14, [
                                              _createVNode(_component_inline_svg, {
                                                src: _ctx.originUrl + menuItem.svgIcon
                                              }, null, 8, ["src"])
                                            ]))
                                          : _createCommentVNode("", true)
                                    ]))
                                  : _createCommentVNode("", true),
                                _createElementVNode("span", _hoisted_15, _toDisplayString(_ctx.translate(menuItem.heading)), 1)
                              ], 8, _hoisted_12))
                            : _createCommentVNode("", true)
                        ], 8, _hoisted_7))
                      : _createCommentVNode("", true)
                  ], 64))
                : _createCommentVNode("", true),
              (menuItem.sectionTitle && _ctx.isUserInheritRoles(menuItem.roles) && _ctx.isFeatureEnabled(menuItem.feature) && !menuItem['isHidden'])
                ? (_openBlock(), _createElementBlock("div", {
                    key: 1,
                    class: _normalizeClass([{ hover: _ctx.isActivePath(menuItem.subsections) }, "menu-item menu-accordion"]),
                    "data-kt-menu-sub": "accordion",
                    "data-kt-menu-trigger": "click"
                  }, [
                    _createElementVNode("span", _hoisted_16, [
                      (menuItem.svgIcon || menuItem.fontIcon)
                        ? (_openBlock(), _createElementBlock("span", _hoisted_17, [
                            (_ctx.asideMenuIcons === 'font')
                              ? (_openBlock(), _createElementBlock("i", {
                                  key: 0,
                                  class: _normalizeClass([menuItem.fontIcon, "bi fs-3"])
                                }, null, 2))
                              : (_ctx.asideMenuIcons === 'svg')
                                ? (_openBlock(), _createElementBlock("span", _hoisted_18, [
                                    _createVNode(_component_inline_svg, {
                                      src: _ctx.originUrl + menuItem.svgIcon
                                    }, null, 8, ["src"])
                                  ]))
                                : _createCommentVNode("", true)
                          ]))
                        : _createCommentVNode("", true),
                      _createElementVNode("span", _hoisted_19, _toDisplayString(_ctx.translate(menuItem.sectionTitle)), 1),
                      _hoisted_20
                    ]),
                    _createElementVNode("div", {
                      class: _normalizeClass([{ hover: _ctx.isActivePath(menuItem.subsections) }, "menu-sub menu-sub-accordion"])
                    }, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(menuItem.sub, (item2, k) => {
                        return (_openBlock(), _createElementBlock(_Fragment, { key: k }, [
                          (item2.heading && _ctx.isUserInheritRoles(item2.roles) && _ctx.isFeatureEnabled(item2.feature))
                            ? (_openBlock(), _createElementBlock("div", _hoisted_21, [
                                (item2.route)
                                  ? (_openBlock(), _createBlock(_component_router_link, {
                                      key: 0,
                                      to: item2.route
                                    }, {
                                      default: _withCtx(({ href, navigate, isExactActive }) => [
                                        _createElementVNode("a", {
                                          class: _normalizeClass([[isExactActive && _ctx.isActivePath(menuItem.subsections) && 'active' && 'active'], "menu-link"]),
                                          href: href,
                                          onClick: navigate
                                        }, [
                                          _hoisted_23,
                                          _createElementVNode("span", _hoisted_24, _toDisplayString(_ctx.translate(item2.heading)), 1)
                                        ], 10, _hoisted_22)
                                      ]),
                                      _: 2
                                    }, 1032, ["to"]))
                                  : _createCommentVNode("", true),
                                (item2.url)
                                  ? (_openBlock(), _createElementBlock("a", {
                                      key: 1,
                                      href: item2.url,
                                      class: "menu-link",
                                      target: "_blank"
                                    }, [
                                      _hoisted_26,
                                      _createElementVNode("span", _hoisted_27, _toDisplayString(_ctx.translate(item2.heading)), 1)
                                    ], 8, _hoisted_25))
                                  : _createCommentVNode("", true)
                              ]))
                            : _createCommentVNode("", true),
                          (item2.sectionTitle && _ctx.isUserInheritRoles(item2.roles) && _ctx.isFeatureEnabled(item2.feature))
                            ? (_openBlock(), _createElementBlock("div", {
                                key: 1,
                                class: _normalizeClass([{ show: _ctx.hasActiveChildren(item2.route), }, "menu-item menu-accordion"]),
                                "data-kt-menu-sub": "accordion",
                                "data-kt-menu-trigger": "click"
                              }, [
                                _createElementVNode("span", _hoisted_28, [
                                  _hoisted_29,
                                  _createElementVNode("span", _hoisted_30, _toDisplayString(_ctx.translate(item2.sectionTitle)), 1),
                                  _hoisted_31
                                ]),
                                _createElementVNode("div", {
                                  class: _normalizeClass([{ show: _ctx.hasActiveChildren(item2.route), }, "menu-sub menu-sub-accordion"])
                                }, [
                                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item2.sub, (item3, k) => {
                                    return (_openBlock(), _createElementBlock(_Fragment, { key: k }, [
                                      (item3.heading && _ctx.isFeatureEnabled(item3.feature))
                                        ? (_openBlock(), _createElementBlock("div", _hoisted_32, [
                                            (item3.route)
                                              ? (_openBlock(), _createBlock(_component_router_link, {
                                                  key: 0,
                                                  to: item3.route
                                                }, {
                                                  default: _withCtx(({ href, navigate }) => [
                                                    _createElementVNode("a", {
                                                      class: _normalizeClass(["menu-link", [_ctx.isActivePath(menuItem.subsections) && 'active']]),
                                                      href: href,
                                                      onClick: navigate
                                                    }, [
                                                      _hoisted_34,
                                                      _createElementVNode("span", _hoisted_35, _toDisplayString(_ctx.translate(item3.heading)), 1)
                                                    ], 10, _hoisted_33)
                                                  ]),
                                                  _: 2
                                                }, 1032, ["to"]))
                                              : _createCommentVNode("", true),
                                            (item3.href)
                                              ? (_openBlock(), _createElementBlock("a", {
                                                  key: 1,
                                                  class: "menu-link",
                                                  href: item3.href,
                                                  target: "_blank"
                                                }, [
                                                  _hoisted_37,
                                                  _createElementVNode("span", _hoisted_38, _toDisplayString(_ctx.translate(item3.heading)), 1)
                                                ], 8, _hoisted_36))
                                              : _createCommentVNode("", true)
                                          ]))
                                        : _createCommentVNode("", true)
                                    ], 64))
                                  }), 128))
                                ], 2)
                              ], 2))
                            : _createCommentVNode("", true)
                        ], 64))
                      }), 128))
                    ], 2)
                  ], 2))
                : _createCommentVNode("", true)
            ], 64))
          }), 128))
        ], 64))
      }), 128))
    ])
  ], 512))
}